import './css/index.css';

import './js/freezeScroll.js';
import './js/videoOverlay.js';

console.log('index.js');